export class Files {
  fileId: number;
  name: string;
  description?: string;
  fileName: string;
  fileCRC?: number;
  fileTypeId: number;
  fileSize: number;
  fileBytes?: Blob[];
  production: number;
  isActive: boolean;
  email?: string;
  userCreateName?: string;
  userUpdateName?: string;
  createDate?: string | number;
  updateDate?: string | number;
  formData: FormData;

  constructor() {
    (this.fileId = -1),
      (this.isActive = false),
      (this.production = 0),
      (this.name = ''),
      (this.fileName = ''),
      (this.fileSize = 0),
      (this.fileTypeId = 1),
      (this.name = ''),
      (this.formData = new FormData());
  }
}
export class FileType {
  id: number;
  name?: string;
  extension?: string;
  placeholder?: string;
  email?: string;
  allowedSendInTheHand: boolean;
  allowedInsertInTheHand: boolean;
  createDate?: string | number;
  updateDate?: string | number;

  constructor() {
    (this.id = 1),
      (this.allowedSendInTheHand = false),
      (this.allowedInsertInTheHand = false);
  }
}

export class StatusOTA {
  serial?: string;
  status?: string;
  versaoInicial?: string;
  versaoFinal?: string;
  versao?: string;
  fileId?: number;
  porcentagem?: number;
  dataHoraUltimoPacoteRecebido?: string | number;

  constructor() {}
}
